import { render } from "./ServiceCategory.vue?vue&type=template&id=ed46d27c"
import script from "./ServiceCategory.vue?vue&type=script&lang=js"
export * from "./ServiceCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__